import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb, VhImage, VhEventMediator, VhAlgorithm } from 'vhautowebdb';
import { MatDialog } from '@angular/material/dialog';
import { NzPlacementType } from 'ng-zorro-antd/dropdown';
import { forkJoin, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { FunctionService, LanguageService } from 'vhobjects-service/src/services';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'atw-frame-product-by-category-config',
  templateUrl: './frame-product-by-category-config.component.html',
  styleUrls: ['./frame-product-by-category-config.component.scss'],
})
export class AtwFrameProductByCategoryConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() position: any; // xác định position là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; @Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Output() changeOptionConfig = new EventEmitter<any>();
  isViewAll: boolean = false;
  isCollapsed: boolean = false;
  positionSelect: NzPlacementType = 'bottomCenter';
  dataConfig: any;
  dataAfterChange: any = {};
  openFixedIdCate: boolean = false;
  currentCategory: any;
  tempSearchCategory = ''; // biến trung gian
  searchCategory = '';
  resultSearchCategory = [];
  private searchCategoryChange = new Subject<string>();
  isLoadingSearchCategory = false;
  public currentViewAll: any = {};
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_phan_tu',
      index: 2,
    },
    {
      title: 'dieu_chinh_hieu_ung',
      index: 3,
    },
  ];
  public optionsBackground = [
    {
      label: 'Hình nền',
      value: 'image',
    },
    {
      label: 'Màu nền',
      value: 'color',
    },
  ];
  public cols: any = [1, 2, 3, 4, 6];
  openBorderConfig: boolean = false;
  public bootstrapIconArrows: any = [
    {
      icon_left: 'bi bi-chevron-left',
      icon_right: 'bi bi-chevron-right',
    },
    {
      icon_left: 'bi bi-arrow-left-short',
      icon_right: 'bi bi-arrow-right-short',
    },
    {
      icon_left: 'bi bi-caret-left-fill',
      icon_right: 'bi bi-caret-right-fill',
    },
    {
      icon_left: 'bi bi-chevron-compact-left',
      icon_right: 'bi bi-chevron-compact-right',
    },
  ];

  fonts = [];
  effect_hover = [];
  customize = [];

  /**
   * biến này lưu danh sách danh mục cho cầu hình hiển thị sản phẩm theo danh mục cố định
   */
  categories: any[] = [];

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private matdialog: MatDialog,
    private vhImage: VhImage,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
    private languageService: LanguageService,
    private vhAlgorithm: VhAlgorithm,
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if(!this.config.hasOwnProperty('fixed_id_category')) {
        this.config.fixed_id_category = 'none';
      }

      forkJoin([
        this.http.get('assets/fonts/fonts.json'),
        this.http.get('assets/data/effects/frame-products.json'),
      ]).subscribe(([fonts, effects]: any) => {
        this.fonts = fonts;
        this.effect_hover = effects;
      });
    }

    if (!this.objectChoosing[this.device + '_class']?.['frame-product-category__notification-text']) {
      this.objectChoosing[this.device + '_class']['frame-product-category__notification-text'] = {
        "color": "#000000",
        "font-size": "16px",
        "font-weight": "normal",
        "font-family": "Arial",
        "text-align": "left",
        "line-height": "1.2"
      }
    }

    if (!this.objectChoosing[this.device + '_config']?.['box-shadow']) {
      this.objectChoosing[this.device + '_config']['box-shadow'] = {
        "property_box_shadow": {
          "v-offset": 1,
          "h-offset": 1,
          "type": "outset",
          "blur": 1,
          "color": "#ffffffff",
          "spread": 1
        },
        "is_box_shadow": false
      }
    }

    if (this.class['frame-product-category__list--wrapper']['box-shadow']) delete this.class['frame-product-category__list--wrapper']['box-shadow'];

    if (!this.objectChoosing[this.device + '_config']?.['animation-selected']) {
      this.objectChoosing[this.device + '_config']['animation-selected'] = {
        "id": "000000"
      }
    }

    if (!this.objectChoosing.staticdata[this.device + '_animation'])
      this.objectChoosing.staticdata[this.device + '_animation'] = { 'animation-0': {} };
    if (!this.objectChoosing.staticdata[this.device + '_animation_type'])
      this.objectChoosing.staticdata[this.device + '_animation_type'] = 'none';

    // đoạn này để xử lý khi người dùng ngưng gõ 300ms thì mới thực hiện tìm kiếm
    this.searchCategoryChange.pipe(
      debounceTime(300), // thay đổi thời gian chờ ở đây
    ).subscribe(newValue => {
      this.isLoadingSearchCategory = false; // người dùng ngừng gõ
      this.handleSearchCategory(newValue);
    });
  }

  getCategories() {
    this.vhQueryAutoWeb
      .getCategorys_byFields({}, {})
      .then((rsp: any) => {
        const categories = rsp.data.map((e) => {
          const array_step = [];
          for (let i = 0; i < e.step; i++) {
            array_step.push(i);
          }

          const item = { ...e, array_step };

          if (e._id === this.objectChoosing[`${this.device}_config`].fixed_id_category) {
            this.currentCategory = item;
          }

          return item;
        });

        this.categories = this.vhAlgorithm.sortVietnamesebyASC(categories, 'name_' + this.functionService.selectedLanguageCode);
      })
      .catch((error) => {
        console.error('Error fetching categories:', error);
      });
  }

  parserPercent = (value: string): string => value.replace('%', '');
  formatterPercent = (value: number): string => {
    return `${value} %`;
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId))
      if (changes) {
        if (changes.objectChoosing) {
          this.dataConfig = this.objectChoosing[`${this.device}_config`];
          this.getCategories();
        }
        if (changes.device) this.device = changes.device.currentValue;
      }
  }

  /**
   * Xử lí thay đổi số cột
   */
  handleChangeCols() {
    // this.class['frame-product-category__list']['grid-template-columns'] = `repeat(${this.dataConfig.cols}, minmax(0px, 1fr))`;
    // cập nhật trường grid-template-columns
    this.class['frame-product-category__list'][
      'grid-template-columns'
    ] = `repeat(${this.config['cols']},${this.calcSpaceGrid(
      this.config.cols
    )})`;

    // cập nhật trường grid-template-rows
    this.class['frame-product-category__list'][
      'grid-template-rows'
    ] = `repeat(${this.config.rows},${this.calcSpaceGrid(this.config.rows)})`;

    // Cập nhật tường grid-auto-columns
    this.class['frame-product-category__list'][
      'grid-auto-columns'
    ] = `${this.calcSpaceGrid(this.config.cols)}`;

    this.config['total_products'] = this.config['cols'] * this.config['rows'];
  }

  /**
   * Xử lí thay đổi số dòng
   */
  handleChangeRows() {
    // this.class['frame-product-category__list']['grid-template-rows'] = `repeat(${this.dataConfig.rows}, minmax(0px, 1fr))`;
    this.class['frame-product-category__list'][
      'grid-template-rows'
    ] = `repeat(${this.config.rows},${this.calcSpaceGrid(this.config.rows)})`;
    this.config['total_products'] = this.config['cols'] * this.config['rows'];
  }
  /** Hàm này trả về một chuỗi để chia layout cho grid
   * @param cols
   * @param gap
   *
   * @example
   * cols = 4
   * gap = 12
   * Kết quả: calc(25% - 9px)
   * @return calc(${100/cols}% - ${(gap/cols)*(cols-1)}px)
   *
   */
  calcSpaceGrid(cols) {
    let gap = parseInt(this.class['frame-product-category__list'].gap, 10);
    return `calc(${100 / cols}% - ${(gap / cols) * (cols - 1)}px)`;
  }

  /** Hàm thực hiện xử lý font-size icon left
   *
   * @param event
   */
  handleFontSizeIconLeft(event) {
    let value = `${event}px`;
    this.class['frame-product-category__left-arrow--icon']['font-size'] =
      this.class['frame-product-category__left-arrow--icon']['height'] =
      this.class['frame-product-category__left-arrow--icon']['width'] =
      value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý font-size icon right
   *
   * @param event
   */
  handleFontSizeIconRight(event) {
    let value = `${event}px`;
    this.class['frame-product-category__right-arrow--icon']['font-size'] =
      this.class['frame-product-category__right-arrow--icon']['height'] =
      this.class['frame-product-category__right-arrow--icon']['width'] =
      value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý icon trái cách bên trái
   *
   * @param event
   */
  handleLeftArrowLeft(event) {
    let value = `${event}%`;
    this.class['frame-product-category__left-arrow']['left'] = value;
    this.updateClass();
  }
  /** Hàm thực hiện xử lý icon phải cách bên phải
   *
   * @param event
   */
  handleRightArrowRight(event) {
    let value = `${event}%`;
    this.class['frame-product-category__right-arrow']['right'] = value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý icon trái cách bên trên
   *
   * @param event
   */
  handleTopArrowLeft(event) {
    let value = `${event}%`;
    this.class['frame-product-category__left-arrow']['top'] = value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý icon phải cách bên trên
   *
   * @param event
   */
  handleTopArrowRight(event) {
    let value = `${event}%`;
    this.class['frame-product-category__right-arrow']['top'] = value;
    this.updateClass();
  }

  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
        // data: this.data
      })
      .then((bool: any) => { });
  }

  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => { });
  }

  updateStaticdata() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        staticdata: this.objectChoosing.staticdata,
      })
      .then((bool: any) => { });
  }

  // xử lý chỉ mở được 1 menu 1 lần
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu14: false,
  };
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  /*--------- Thay đổi mũi tên điều hướng trang -------------------*/
  onChangeArrows(arrows) {
    this.dataConfig.icon_pagination.arrow_left_icon = arrows.icon_left;
    this.dataConfig.icon_pagination.arrow_right_icon = arrows.icon_right;
    this.updateConfig();
  }

  //Hàm update position
  updatePosition() {
    this.vhQueryAutoWeb
      .updateBlock(this.objectChoosing._id, {
        [this.device + 'position']: this.position,
      })
      .then((bool: any) => { });
  }

  // PHẦN DOTS - Nút phân trang

  /**
   * Kiểu nút slide
   * @param event
   */
  handleSetDotsStyle(event) {
    switch (event) {
      case 'circle':
        this.class['frame-product-category__pagination-list-button--controll'][
          'border-radius'
        ] = 50 + 'px';
        this.class[
          'frame-product-category__pagination-list-button--page-number'
        ]['border-radius'] = 50 + 'px';
        this.class['frame-product-category__pagination-list-button--active'][
          'border-radius'
        ] = 50 + 'px';
        this.config[`slick_dots`]['height'] =
          this.config[`slick_dots`]['width'];
        break;
      case 'rectangle':
        this.class['frame-product-category__pagination-list-button--controll'][
          'border-radius'
        ] = 0 + '%';
        this.class[
          'frame-product-category__pagination-list-button--page-number'
        ]['border-radius'] = 0 + '%';
        this.class['frame-product-category__pagination-list-button--active'][
          'border-radius'
        ] = 0 + '%';
        break;
    }

    this.updateConfig();
    this.updateClass();
  }

  /**
   * Kích thước cho nút next/prev
   *  @param event
   *  @param type nút next hay prev
   */
  handleSetButtonSize(event) {
    var style = this.config[`slick_dots`]['background_style'];

    this.config[`slick_dots`]['width'] = event + 'px';
    this.config['slick_dots']['height'] = event + 'px';
    this.class['frame-product-category__pagination-list-button--controll'][
      'border-radius'
    ] = 50 + 'px';
    this.class['frame-product-category__pagination-list-button--page-number'][
      'border-radius'
    ] = 50 + 'px';
    this.class['frame-product-category__pagination-list-button--active'][
      'border-radius'
    ] = 50 + 'px';
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width)
      this.class['frame-product-category']['width'] = event.width + 'px';
    if (event.height)
      this.class['frame-product-category']['height'] = event.height + 'px';
    this.updateClass();
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylesField[2]);
  }

  updateTypeDisplay(){
    this.class['frame-product-category__pagination']['display'] = 'flex'; // bảo toàn dữ liệu cũ
    this.updateConfig();
    this.updateClass();
    this.functionService.updateDimension(this.objectChoosing)
  }

  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation(); // ✅ chặn click lan ra ngoài
    this.openFixedIdCate = !this.openFixedIdCate;

    if (this.openFixedIdCate && this.currentCategory?._id !== undefined && this.currentCategory?._id !== 'none') {
      const linkToSearch = this.currentCategory._id;
      setTimeout(() => {
        const selector = `[data-id="${this.currentCategory._id}"]`;
        const targetElement = document.querySelector(selector); 

        if (targetElement) {
          // Thực hiện cuộn
          targetElement.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
        } else {
          console.warn(`Không tìm thấy mục với link "${linkToSearch}" trong dropdown.`);
        }
      }, 100);
    }
  }

  trackByPage(index: number, item: any) {
    return item._id;
  }

  /**
   * Chọn danh mục
   * @param cate: mục danh mục sẽ chọn
   */
  chooseCategory(cate) {
    this.openFixedIdCate = false;
    this.config.fixed_id_category = cate === 'none' ? 'none' : cate._id;
    this.currentCategory = cate;

    this.updateConfig();
  }

  /**
   * 
   * @param value giá trị tìm kiếm
   * sau khi người dùng ngưng gõ 300ms mới thực hiện hàm này
   */
  private handleSearchCategory(value: string): void {
    const resultSearchCategory = this.searchList(value, JSON.parse(JSON.stringify(this.categories)), ['name_' + this.functionService.selectedLanguageCode]);
    this.resultSearchCategory = this.vhAlgorithm.sortStringbyASC(resultSearchCategory, 'name_' + this.functionService.selectedLanguageCode);
  }

  /**
   * 
   * @param str hàm bỏ dấu tiếng việt
   * @returns 
   */
  private removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D");
  }

  /**
   * 
   * @param value giá trị tìm kiếm
   * @param data dữ liệu cần tìm kiếm
   * @param field trường cần tìm kiếm
   * @returns 
   */
  private searchList(value: string, data: any[] = [], field: string[]): any[] {
    let result = [];
    value = this.removeAccents(value.toLowerCase());
    for (let item of data) {
      let itemValue = this.removeAccents(item[field[0]].toLowerCase());
      itemValue = this.removeAccents(this.languageService.translate(itemValue).toLowerCase());
      if (itemValue.includes(value)) {
        result.push(item);
      }
    }
    return result;
  }

  /**
   * 
   * @param value giá trị tìm kiếm
   * hàm này thực hiện gọi hàm searchValueChange.next(value) để thực hiện tìm kiếm
   * 
   */
  onSearchCategoryChange(value: string) {
    this.isLoadingSearchCategory = true; // Thiết lập isLoading thành true trước khi gán giá trị cho tempSearchValue
    this.tempSearchCategory = value;
    this.searchCategoryChange.next(value);
  }
}
